import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from "@angular/core";
import { NgModel } from "@angular/forms";

@Component({
    selector: 'inline-input',
    templateUrl: 'inline-input.component.html',
    moduleId: module.id.toString()
})
export class InlineInputComponent {
    @Input()
    public model: string;

    @Input()
    public name: string;

    @Output()
    public changeEvent: EventEmitter<string> = new EventEmitter();

    public isEditing: boolean = false;
    public isValid: boolean = true;

    private prevValue: string;

    @ViewChild('inputRefId')
    public inputReference: ElementRef;

    @ViewChild(NgModel) modelRef: NgModel;

    public emmitModify(): void {
        if (!this.modelRef.valid)
            return;

        this.isEditing = !this.isEditing;

        if (this.model != this.prevValue)
            this.changeEvent.emit(this.model);
    }

    public open(): void {
        this.prevValue = this.model;

        this.isEditing = !this.isEditing;
        setTimeout(() => this.inputReference.nativeElement.focus(), 0);
    }
}


// WEBPACK FOOTER //
// ./app/components/common/inline-input/inline-input.component.ts